import { dom, library } from "@fortawesome/fontawesome-svg-core"
import { faAngleRight, faEnvelope, faCheckCircle } from "@fortawesome/free-solid-svg-icons"
import {
  faInstagram,
  faTwitter,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons"

// faAngleLeft / faFolderOpen / faGoogle を削除した（Issue #135）。
// いずれもビューで一度も使われていなかった（fa-angle-left / fa-folder-open /
// fa-google の出現箇所は、ベンダー CSS や kartik テーマなどライブラリ側の定義のみ）。
//
// なお kartik のファイル入力（theme: 'fa'）は fa-folder-open を使うが、それを呼ぶ
// public/orders/_form.html.erb と public/temp_portfolio_images/_form.html.erb は
// どちらも**ルートが存在せず到達不能**（rails routes で確認。Issue #81 / #155）。
//
// 仮に到達できたとしても表示されない。これらは layout "users" 配下でフォント版の
// FA CSS を読まず、かつ iconToSvg() は ready 時の一回限り（dom.watch() 未使用）で、
// kartik はその後に DOM を注入するため i2svg が拾えない（Fable 指摘）。
// SVG 経路を直すときは faFolderOpen の再追加と dom.watch() の導入がセットで要る。
//
// 登録を減らしておくと、依存を上げるとき（FA 5 → 7）に実ブラウザで確認すべき
// アイコンが 9 → 6 に減る。
library.add(faAngleRight, faEnvelope, faCheckCircle)
library.add(faInstagram, faFacebookF, faTwitter)

export const iconToSvg = () => {
  dom.i2svg()
}
